
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {Guid} from 'guid-typescript';

  import {getMapPointItems} from '@/api/map';

  import {ImagePreview} from 'vant';

  import ProgressCircle from './progress-circle.vue';

  import {Pause, PlayOne} from '@icon-park/vue';

  @Component({
    components: {
      ProgressCircle,
      Pause,
      PlayOne
    }
  })
  export default class PointContent extends Vue {
    @Prop({required: true, default: () => false}) private show!: boolean;
    @Prop({required: true}) private pointId!: Guid;
    @Prop({required: true, default: () => ''}) private title!: string;
    @Prop({default: () => false}) private isNavigation!: boolean;
    @Prop({default: () => ''}) private mapUrl!: string;
    @Prop({}) private percent!: number;
    @Prop({default: () => false}) private isPlaying!: boolean;
    @Prop({default: () => false}) private isPause!: boolean;
    @Prop({default: () => false}) private isRoom!: boolean;

    private currentShow = this.show;
    private pointItem = {
      fileList: [],
      introduction: '',
      businessHours: '',
      contactNumber: '',
      audioUrl: '',
      address: '',
      chineseAudioFile: '',
      inUrl: '',
      outUrl: ''
    };

    private grid = 0;

    private baseUrl = Vue.prototype.$appsettings.serverUrl + '/';
    private radius = '1.54rem';

    private async mounted() {
      await this.getItems();
    }

    private destroyed() {
      // if (this.audio) {
      //   this.audio.pause();
      //   clearInterval(this.timer);
      // }
    }

    get color() {
      let color = this.$store.getters.background;
      if (!color) {
        color = '#4B9CFC';
      }
      return color;
    }

    private async getItems() {
      if (this.pointId) {
        const result = await getMapPointItems(this.pointId);
        this.pointItem = Object.assign({fileList: []}, result);
        this.pointItem.audioUrl = '';
        this.pointItem.chineseAudioFile = '';
        if (result.audioFile) {
          this.pointItem.audioUrl = this.baseUrl + result.audioFile;
        }

        if (result.vrUrl) {
          this.grid = this.pointItem.fileList.length + 1;
        }

        if (result.chineseAudioFile) {
          this.pointItem.chineseAudioFile = this.baseUrl + result.chineseAudioFile;
        }

        if (!this.isPlaying) {
          this.$emit('playAudio', this.pointItem.audioUrl, this.pointItem.chineseAudioFile);
          if (result.autoExplanation) {
            this.handlerPlay();
          }
        }
      }
    }

    private handlerPlay() {
      this.$emit('handlerPlay');
    }

    private handlerPause() {
      this.$emit('handlerPause');
    }

    private handlerClose() {
      this.$emit('close', false);
    }

    private handlePreview(index: number) {
      const that = this
      if (this.pointItem.fileList.length > 0) {
        const images = this.pointItem.fileList.map((value: any) => that.baseUrl + value.filePath);
        ImagePreview({images, startPosition: index, closeable: true});
      }
    }

    private handleHref(url: string) {
      window.location.href = url;
    }

    private handleOtherNavigation() {
      window.location.href = this.mapUrl;
    }
  }
